import { generatedApi } from '@shared/api/generated-api';
import type { RootState } from '@shared/redux';

export const integrationsEndpoints = {
  webhookListIntegrationWebhookListGet: {
    providesTags: ['integration'],
  },

  webhookInfoIntegrationWebhookInfoGet: {
    providesTags: ['integration'],
  },

  webhookUpdateIntegrationWebhookUpdatePost: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;

        const webhookListIntegrationWebhookListGetArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'webhookListIntegrationWebhookListGet',
        );

        const webhookInfoIntegrationWebhookInfoGetArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'webhookInfoIntegrationWebhookInfoGet',
        );

        for (const args of webhookListIntegrationWebhookListGetArgs) {
          dispatch(
            generatedApi.util.updateQueryData(
              'webhookListIntegrationWebhookListGet',
              args,
              (draft) => {
                const webhook = draft.find((item) => item.id === data.id);

                if (webhook) {
                  webhook.callback_url = data.callback_url;
                  webhook.channel_id = data.channel_id;
                  webhook.title = data.title;
                  webhook.method = data.method;
                }
              },
            ),
          );
        }

        for (const args of webhookInfoIntegrationWebhookInfoGetArgs) {
          if (args.webhookIntegrationId !== data.id) return;

          dispatch(
            generatedApi.util.updateQueryData(
              'webhookInfoIntegrationWebhookInfoGet',
              args,
              (draft) => {
                Object.assign(draft, data);
              },
            ),
          );
        }
      } catch (error) {}
    },
  },

  webhookCreateIntegrationWebhookCreatePost: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;

        const webhookListIntegrationWebhookListGetArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'webhookListIntegrationWebhookListGet',
        );

        for (const args of webhookListIntegrationWebhookListGetArgs) {
          dispatch(
            generatedApi.util.updateQueryData(
              'webhookListIntegrationWebhookListGet',
              args,
              (draft) => {
                draft.push(data);
              },
            ),
          );
        }
      } catch (error) {}
    },
  },

  webhookDeleteIntegrationWebhookDeleteDelete: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        await queryFulfilled;

        const webhookListIntegrationWebhookListGetArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'webhookListIntegrationWebhookListGet',
        );

        for (const args of webhookListIntegrationWebhookListGetArgs) {
          dispatch(
            generatedApi.util.updateQueryData(
              'webhookListIntegrationWebhookListGet',
              args,
              (draft) => {
                const index = draft.findIndex((item) => item.id === arg.webhookIntegrationId);
                if (index !== -1) {
                  draft.splice(index, 1);
                }
              },
            ),
          );
        }
      } catch (error) {}
    },
  },

  webhookFieldCreateIntegrationWebhookFieldCreatePost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;

        const webhookInfoIntegrationWebhookInfoGetArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'webhookInfoIntegrationWebhookInfoGet',
        );

        for (const args of webhookInfoIntegrationWebhookInfoGetArgs) {
          if (args.webhookIntegrationId !== arg.webhookIntegrationId) continue;

          dispatch(
            generatedApi.util.updateQueryData(
              'webhookInfoIntegrationWebhookInfoGet',
              args,
              (draft) => {
                Object.assign(draft, data);
              },
            ),
          );
        }
      } catch (error) {}
    },
  },

  webhookFieldDeleteIntegrationWebhookFieldDelete: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;

        const webhookInfoIntegrationWebhookInfoGetArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'webhookInfoIntegrationWebhookInfoGet',
        );

        for (const args of webhookInfoIntegrationWebhookInfoGetArgs) {
          if (args.webhookIntegrationId !== data.id) continue;

          dispatch(
            generatedApi.util.updateQueryData(
              'webhookInfoIntegrationWebhookInfoGet',
              args,
              (draft) => {
                Object.assign(draft, data);
              },
            ),
          );
        }
      } catch (error) {}
    },
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
